import {safeLocalStorage} from './utils/safeLocalStorage.js';
import { isApp } from './utils';
import { delegateListener } from './utils/delegate-listener';

const EVENT_BANNER_CLOSED = 'banner-closed';
const CLOSET_PRICE_DROP_BANNER_STORAGE_KEY = 'showClosetPriceDropBanner';
const CLOSET_PRICE_DROP_ID = 'price-drop-closet-banner';

const setClosetPriceDropBanner = () => {
    if (!safeLocalStorage.getItem(CLOSET_PRICE_DROP_BANNER_STORAGE_KEY)) {
        const banner = document.getElementById(CLOSET_PRICE_DROP_ID);
        if (banner) {
            banner.classList.remove("display-none");
        }
    }
    document.addEventListener(EVENT_BANNER_CLOSED, e => {
      if (e.detail?.id === CLOSET_PRICE_DROP_ID) {
          safeLocalStorage.setItem(CLOSET_PRICE_DROP_BANNER_STORAGE_KEY, '0');
      }
  })
};

const setBannerCloseButton = () => {
    setClosetPriceDropBanner();

    delegateListener('click', '.js-close-banner-button', e => {
        e.preventDefault();
        const banner = e.target?.closest('.banner-info');
        if (banner) {
            const bannerClosedEvent = new CustomEvent(
                EVENT_BANNER_CLOSED,
                {
                    detail: {
                        id: banner.id
                    }
                }
            );
            banner.remove();
            document.dispatchEvent(bannerClosedEvent);
        }
    });
};

const removeAlertOnLinkClick = () => { // Función de mierda para cerrar banners que al volver atrás en la app siguen ahí
    if (!isApp()) return;
    document.querySelectorAll('.js-remove-alert-on-click').forEach(link => {
        link.addEventListener('click', () => {
            setTimeout(() => {
                link.closest('.alert').remove();
            },3000);
        });
    });
};

export {setBannerCloseButton, removeAlertOnLinkClick};
